// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TaobaoCircleFilledSvg from "@ant-design/icons-svg/es/asn/TaobaoCircleFilled";
import AntdIcon from '../components/AntdIcon';

var TaobaoCircleFilled = function TaobaoCircleFilled(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: TaobaoCircleFilledSvg
  }));
};

TaobaoCircleFilled.displayName = 'TaobaoCircleFilled';
export default React.forwardRef(TaobaoCircleFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_icons@4.0.6@@ant-design/icons/es/icons/TaobaoCircleFilled.js
// module id = 1923
// module chunks = 0